module.exports = __webpack_public_path__ + "img/9788952735805.05c00aa1.jpg";